import { render, staticRenderFns } from "./TestingTools_writing.vue?vue&type=template&id=fa4c6bec&scoped=true"
import script from "./TestingTools_writing.vue?vue&type=script&lang=js"
export * from "./TestingTools_writing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4c6bec",
  null
  
)

export default component.exports